import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import type { IEquipmentVehicleInfo as IEquipmentInfo, Ticket, TicketDeliveryProduct } from "@kiraah-shared/common";
import { TranslateModule } from "@ngx-translate/core";
import type { MobileTicketWizardComponent } from "../../mobile-ticket-wizard-page.component";

/** Équivalent mobile de `TicketEquipmentSelectionComponent` : catalogue équipement + vue « sélection ». */
@Component({
  selector: "mobile-ticket-vehicle-selection-step",
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: "./mobile-ticket-vehicle-selection-step.component.html",
  styleUrl: "./mobile-ticket-vehicle-selection-step.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTicketEquipmentSelectionStepComponent {
  readonly wizard = input.required<MobileTicketWizardComponent>();
  readonly ticket = input.required<Ticket>();

  protected lineTrack(index: number, line: TicketDeliveryProduct): string {
    return this.wizard().selectionLineTrack(index, line);
  }

  protected fleetCatalogTrack(index: number, row: IEquipmentInfo): string {
    return this.wizard().fleetCatalogTrack(index, row);
  }
}
